

































































import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'
import { ActionMenu } from '@/tcw/domain/types'
import BaseComponent from '@/tcw/components/BaseComponent'
import { ButtonType } from 'element-ui/types/button'

@Component
export default class TcwDialog extends Mixins(BaseComponent) {
  @Prop({ default: 600 })
  private maxWidth!: number
  @Prop({ default: false })
  private open!: boolean
  @Prop({ default: null })
  private actions!: ActionMenu[] | null
  @Prop({ type: Boolean, default: true })
  private hasOk!: string
  @Prop({ default: 'OK' })
  private okLabel!: string
  @Prop({ default: 'primary' })
  private okButtonType!: ButtonType
  @Prop({ type: Boolean, default: true })
  private hasCancel!: string
  @Prop({ default: 'キャンセル' })
  private cancelLabel!: string
  @Prop({ default: 'danger' })
  private cancelButtonType!: ButtonType
  @Prop({ type: Boolean, default: false })
  private fullScreen!: string

  @Emit('update:open')
  private updateOpen(_isOpen: boolean): void {
    /** */
  }

  @Emit()
  private ok(): void {
    /** */
  }

  @Emit()
  private cancel(): void {
    this.updateOpen(false)
  }
}
